import { NUTRIENTS, type Nutrient, type Nutrients } from '~/data/nutrition'

/** What the nutrient fields hold, as typed: a string apiece, empty for unknown. */
export type NutrientText = Record<Nutrient, string>

export const EMPTY_NUTRIENT_TEXT: NutrientText = Object.fromEntries(
  NUTRIENTS.map((name) => [name, '']),
) as NutrientText

/** The fields seeded from nutrients as they are kept. */
export function nutrientText(nutrients: Nutrients | null): NutrientText {
  if (nutrients === null) {
    return EMPTY_NUTRIENT_TEXT
  }
  return Object.fromEntries(
    NUTRIENTS.map((name) => {
      const value = nutrients[name]
      return [name, value === null ? '' : String(value)]
    }),
  ) as NutrientText
}

/**
 * What was typed, as nutrients — or null while there are no calories, which is the one a
 * food or a quick add cannot be saved without. An empty field is a nutrient nobody knows.
 */
export function nutrientsTyped(
  text: NutrientText,
): (Partial<Nutrients> & { calories: number }) | null {
  const calories = numberIn(text.calories)
  if (calories === null) {
    return null
  }
  const out: Record<string, number | null> = { calories }
  for (const name of NUTRIENTS) {
    if (name !== 'calories') {
      out[name] = numberIn(text[name])
    }
  }
  return out as Partial<Nutrients> & { calories: number }
}

function numberIn(typed: string): number | null {
  const read = Number(typed)
  return typed.trim() !== '' && Number.isFinite(read) && read >= 0 ? read : null
}
